export default __webpack_public_path__ + "static/media/banner3.dd3ae049.png";